import Field from './base';
import fieldOutput from './field-output';
import formatTimestamp from 'src/utils/format-timestamp';

export default class Timestamp extends Field {
  static outputs = [
    fieldOutput('as_string', 'string_format', 'string'),
    fieldOutput('as_time_string', 'string_format', 'string'),
  ];

  renderString(value) {
    const format = this.params.format || 'date';
    if (!value || !value.ts) {
      return '';
    }
    const formatters = {
      date: (v) =>
        formatTimestamp(v.ts, 'MM/DD/YYYY', v.timezone || 'US/Pacific'),
      time: (v) =>
        formatTimestamp(v.ts, 'h:mm A z', v.timezone || 'US/Pacific'),
    };
    return (formatters[format] || ((v) => v || ''))(value);
  }
}
